module.exports = __webpack_public_path__ + "static/media/LogoSimple.0621bfc3.svg";